__turbopack_context__.v({
  "e-input": "GiveAwayPage-module__gVA8cG__e-input",
  "email-input": "GiveAwayPage-module__gVA8cG__email-input",
  "email-input__input": "GiveAwayPage-module__gVA8cG__email-input__input",
  "email-input__title": "GiveAwayPage-module__gVA8cG__email-input__title",
  "error": "GiveAwayPage-module__gVA8cG__error",
  "giveaway__copy": "GiveAwayPage-module__gVA8cG__giveaway__copy",
  "giveaway__page": "GiveAwayPage-module__gVA8cG__giveaway__page",
  "giveaway__page__bookcopy": "GiveAwayPage-module__gVA8cG__giveaway__page__bookcopy",
  "giveaway__page__button__links": "GiveAwayPage-module__gVA8cG__giveaway__page__button__links",
  "giveaway__page__downloadwindow__copy": "GiveAwayPage-module__gVA8cG__giveaway__page__downloadwindow__copy",
  "giveaway__page__emailCopy": "GiveAwayPage-module__gVA8cG__giveaway__page__emailCopy",
  "giveawaypage__book_image": "GiveAwayPage-module__gVA8cG__giveawaypage__book_image",
  "giveawaypage__bookimage": "GiveAwayPage-module__gVA8cG__giveawaypage__bookimage",
  "giveawaypage__download_button_section": "GiveAwayPage-module__gVA8cG__giveawaypage__download_button_section",
  "giveawaypage__errors": "GiveAwayPage-module__gVA8cG__giveawaypage__errors",
  "img": "GiveAwayPage-module__gVA8cG__img",
  "section": "GiveAwayPage-module__gVA8cG__section",
  "ul": "GiveAwayPage-module__gVA8cG__ul",
});
